__turbopack_context__.v({
  "container": "AccountSearchView-module__LlCZxq__container",
  "searchWrapper": "AccountSearchView-module__LlCZxq__searchWrapper",
  "spinner": "AccountSearchView-module__LlCZxq__spinner",
  "view": "AccountSearchView-module__LlCZxq__view",
});
